(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7724,65250],{

/***/ 7724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FastDebtConsolidationWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/styles/variables/fastdebtconsolidationVariables.module.scss
var fastdebtconsolidationVariables_module = __webpack_require__(88043);
var fastdebtconsolidationVariables_module_default = /*#__PURE__*/__webpack_require__.n(fastdebtconsolidationVariables_module);
;// CONCATENATED MODULE: ./src/components/fastdebtconsolidation/logo/index.tsx


function FastDebtConsolidationLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "325",
        height: "35",
        fill: "none",
        viewBox: "0 0 325 35",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_0_5)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#0067A5",
                        d: "M40.265 8.9h11.78v2.819h-8.629v4.969h7.456v2.653h-7.456v6.75H40.27V8.898h-.005zM55.041 25.555c-.934-.612-1.666-1.448-2.201-2.502-.53-1.054-.794-2.207-.794-3.463 0-1.257.264-2.399.804-3.453.535-1.054 1.267-1.89 2.202-2.508a5.51 5.51 0 013.105-.93c1.059 0 2.004.23 2.824.691a4.563 4.563 0 011.864 1.9v-2.2h2.908v12.99h-2.908v-2.186c-.42.81-1.043 1.438-1.864 1.895-.82.457-1.76.68-2.814.68a5.53 5.53 0 01-3.12-.924l-.005.01zm5.785-2.445a3.838 3.838 0 001.386-1.464 4.216 4.216 0 00.503-2.056c0-.753-.17-1.423-.514-2.04a3.985 3.985 0 00-1.386-1.475 3.55 3.55 0 00-1.921-.545c-.7 0-1.34.17-1.921.514a3.755 3.755 0 00-1.386 1.433c-.343.612-.514 1.318-.514 2.108 0 .789.171 1.531.519 2.15.348.617.81 1.084 1.391 1.416a3.77 3.77 0 001.911.494c.696 0 1.34-.177 1.926-.535h.005zM70.41 25.846c-.841-.42-1.47-.976-1.885-1.666a4.236 4.236 0 01-.618-2.223l2.934.01c.026.624.27 1.128.727 1.512.457.384 1.111.576 1.952.576.769 0 1.345-.145 1.73-.436.389-.29.58-.69.58-1.205 0-.353-.098-.638-.3-.851-.203-.213-.499-.38-.883-.499-.39-.12-.904-.228-1.553-.327-1.417-.187-2.544-.592-3.385-1.215-.84-.623-1.261-1.557-1.261-2.803 0-.8.192-1.501.57-2.103.38-.602.935-1.07 1.667-1.402.732-.332 1.62-.498 2.653-.498 1.034 0 1.953.176 2.742.524.79.348 1.407.841 1.843 1.474a3.74 3.74 0 01.66 2.176l-2.996-.026a1.577 1.577 0 00-.629-1.194c-.384-.301-.919-.447-1.61-.447-.622 0-1.095.135-1.417.405-.322.27-.477.613-.477 1.039 0 .337.072.602.213.789.14.187.405.348.784.477.379.13.95.255 1.718.374 1.013.15 1.859.364 2.544.634.686.27 1.23.67 1.636 1.2.405.529.607 1.235.607 2.112 0 .93-.233 1.709-.7 2.347-.468.639-1.112 1.111-1.927 1.428-.815.317-1.76.473-2.83.473-1.215 0-2.243-.213-3.084-.634l-.005-.02zM83.224 25.057C82.41 24.372 82 23.07 82 21.147v-5.42h-2.695V13.1H82V9.294l3.058-.026V13.1h3.894v2.627h-3.894v5.56c0 1.506.628 2.264 1.885 2.264h2.01v2.54h-2.644c-1.24 0-2.269-.343-3.084-1.029v-.005zM103.572 8.9c1.812 0 3.406.358 4.792 1.074 1.382.717 2.451 1.724 3.209 3.022.758 1.298 1.137 2.793 1.137 4.486 0 1.692-.379 3.203-1.137 4.507-.758 1.303-1.822 2.31-3.198 3.027-1.376.716-2.96 1.074-4.767 1.074h-6.661V8.9h6.625zm3.167 13.686a4.793 4.793 0 002.077-2c.478-.866.722-1.884.722-3.057 0-1.174-.239-2.197-.717-3.08a4.89 4.89 0 00-2.076-2.04c-.909-.478-1.999-.722-3.261-.722h-3.437v11.59h3.463c1.246 0 2.321-.234 3.229-.697v.006zM127.129 20.4h-10.151c.099.69.322 1.287.665 1.796.342.509.768.893 1.277 1.158.509.265 1.064.4 1.661.4.759 0 1.382-.15 1.864-.447a2.65 2.65 0 001.07-1.298h3.339a6.01 6.01 0 01-1.2 2.223 6.246 6.246 0 01-2.155 1.635c-.861.41-1.812.613-2.85.613-1.272 0-2.425-.307-3.453-.925a6.534 6.534 0 01-2.414-2.502c-.582-1.054-.872-2.207-.872-3.463 0-1.257.29-2.41.872-3.463a6.534 6.534 0 012.414-2.503c1.028-.613 2.176-.924 3.453-.924 1.277 0 2.404.301 3.401.908a6.422 6.422 0 012.321 2.436 6.868 6.868 0 01.825 3.317c0 .286-.021.634-.062 1.039h-.005zm-3.058-2.363a2.486 2.486 0 00-.546-1.334 3.373 3.373 0 00-1.246-.971 3.837 3.837 0 00-1.651-.358c-.815 0-1.547.223-2.191.675-.644.451-1.09 1.116-1.334 1.988h6.968zM133.951 25.79a4.851 4.851 0 01-1.874-1.89v2.185h-2.908V8.292h3.058v5.218l-.078 1.708a4.917 4.917 0 011.828-1.817 4.959 4.959 0 012.56-.68c1.204 0 2.29.306 3.255.924a6.411 6.411 0 012.264 2.497c.545 1.049.815 2.202.815 3.458 0 1.257-.275 2.42-.82 3.468-.551 1.05-1.298 1.88-2.259 2.498-.955.613-2.03.924-3.214.924a5.17 5.17 0 01-2.622-.69l-.005-.01zm3.977-2.628a3.666 3.666 0 001.392-1.423c.348-.612.519-1.329.519-2.15 0-.82-.171-1.495-.514-2.107a3.7 3.7 0 00-1.391-1.433 3.81 3.81 0 00-1.927-.514c-.696 0-1.329.176-1.916.535a3.888 3.888 0 00-1.391 1.474 4.18 4.18 0 00-.514 2.046c0 .737.171 1.474.519 2.092.348.618.81 1.106 1.397 1.454a3.689 3.689 0 001.916.524c.69 0 1.329-.166 1.91-.498zM147.378 25.057c-.815-.685-1.225-1.988-1.225-3.91v-5.42h-2.695V13.1h2.695V9.294l3.058-.026V13.1h3.894v2.627h-3.894v5.56c0 1.506.628 2.264 1.884 2.264h2.01v2.54h-2.643c-1.241 0-2.269-.343-3.084-1.029v-.005zM164.392 25.25a8.851 8.851 0 01-3.291-3.262c-.805-1.37-1.205-2.881-1.205-4.522 0-1.64.4-3.146 1.205-4.517a8.877 8.877 0 013.291-3.255c1.392-.8 2.913-1.2 4.575-1.2 1.261 0 2.476.25 3.645.748a7.847 7.847 0 013.006 2.264c.836 1.012 1.386 2.243 1.635 3.702h-3.208c-.327-1.272-.951-2.228-1.87-2.872-.919-.638-2.019-.96-3.297-.96-1.079 0-2.061.254-2.949.763a5.58 5.58 0 00-2.113 2.155c-.519.93-.779 1.988-.779 3.183 0 1.194.26 2.279.774 3.198a5.42 5.42 0 002.103 2.129c.888.498 1.874.753 2.964.753 1.283 0 2.378-.317 3.297-.956.919-.638 1.537-1.589 1.859-2.86h3.225c-.255 1.463-.795 2.704-1.631 3.717-.836 1.012-1.833 1.765-3.001 2.253a9.313 9.313 0 01-3.66.738c-1.662 0-3.183-.4-4.575-1.2zM181.786 25.555a6.637 6.637 0 01-2.445-2.497c-.592-1.049-.883-2.207-.883-3.468 0-1.262.296-2.41.883-3.463a6.614 6.614 0 012.445-2.503c1.038-.613 2.207-.924 3.505-.924s2.482.306 3.525.924a6.557 6.557 0 012.451 2.503 6.995 6.995 0 01.882 3.463c0 1.256-.295 2.425-.882 3.473a6.558 6.558 0 01-2.456 2.498c-1.049.612-2.227.913-3.531.913-1.303 0-2.456-.306-3.494-.924v.005zm5.473-2.44a3.715 3.715 0 001.365-1.438c.332-.613.498-1.308.498-2.087 0-.78-.166-1.46-.498-2.077a3.695 3.695 0 00-1.371-1.454 3.72 3.72 0 00-1.947-.524c-.716 0-1.365.176-1.947.524a3.7 3.7 0 00-1.37 1.454c-.333.618-.499 1.313-.499 2.077 0 .763.166 1.47.499 2.087a3.68 3.68 0 001.365 1.438c.576.348 1.231.52 1.952.52.722 0 1.376-.172 1.953-.52zM197.212 13.095v2.024c.379-.726.966-1.308 1.765-1.75.795-.44 1.688-.664 2.674-.664 1.729 0 3.027.55 3.905 1.64.877 1.091 1.313 2.675 1.313 4.741v7h-3.058v-6.938c0-1.246-.26-2.165-.784-2.746-.524-.587-1.262-.878-2.222-.878-.613 0-1.184.156-1.708.463-.525.306-.94.757-1.257 1.35-.317.591-.472 1.297-.472 2.118v6.635h-3.059V13.1h2.908l-.005-.005zM211.433 25.846c-.841-.42-1.469-.976-1.885-1.666a4.24 4.24 0 01-.618-2.223l2.934.01c.026.624.27 1.128.727 1.512.457.384 1.111.576 1.952.576.768 0 1.345-.145 1.729-.436.389-.29.582-.69.582-1.205 0-.353-.099-.638-.302-.851-.202-.213-.498-.38-.882-.499-.39-.12-.904-.228-1.553-.327-1.417-.187-2.544-.592-3.385-1.215-.841-.623-1.262-1.557-1.262-2.803 0-.8.192-1.501.566-2.103.379-.602.935-1.07 1.667-1.402.732-.332 1.62-.498 2.653-.498s1.952.176 2.742.524c.789.348 1.407.841 1.843 1.474a3.74 3.74 0 01.659 2.176l-2.996-.026a1.587 1.587 0 00-.623-1.194c-.384-.301-.919-.447-1.609-.447-.623 0-1.096.135-1.418.405-.322.27-.477.613-.477 1.039 0 .337.072.602.212.789.146.192.405.348.784.477.379.13.951.255 1.719.374 1.013.15 1.859.364 2.544.634.686.27 1.231.67 1.636 1.2.405.529.607 1.235.607 2.112 0 .93-.233 1.709-.701 2.347-.467.639-1.111 1.111-1.926 1.428-.815.317-1.76.473-2.83.473-1.215 0-2.243-.213-3.084-.634l-.005-.02zM224.392 25.555a6.644 6.644 0 01-2.445-2.497c-.592-1.049-.883-2.207-.883-3.468 0-1.262.296-2.41.883-3.463a6.621 6.621 0 012.445-2.503c1.039-.613 2.207-.924 3.505-.924s2.482.306 3.526.924a6.555 6.555 0 012.45 2.503 6.996 6.996 0 01.883 3.463c0 1.256-.296 2.425-.883 3.473a6.55 6.55 0 01-2.456 2.498c-1.048.612-2.227.913-3.53.913s-2.456-.306-3.495-.924v.005zm5.473-2.44a3.715 3.715 0 001.365-1.438c.333-.613.499-1.308.499-2.087 0-.78-.166-1.46-.499-2.077a3.7 3.7 0 00-1.37-1.454 3.725 3.725 0 00-1.947-.524 3.72 3.72 0 00-1.947.524 3.695 3.695 0 00-1.371 1.454c-.332.618-.498 1.313-.498 2.077 0 .763.166 1.47.498 2.087a3.675 3.675 0 001.366 1.438c.576.348 1.23.52 1.952.52.721 0 1.376-.172 1.952-.52zM236.911 8.276h3.058v17.81h-3.058V8.275zM243.162 10.571c-.343-.332-.514-.753-.514-1.256 0-.504.171-.914.514-1.246.343-.333.805-.499 1.386-.499.582 0 1.059.166 1.402.499.343.332.519.747.519 1.246 0 .498-.171.934-.519 1.261-.348.327-.815.493-1.417.493-.603 0-1.028-.166-1.371-.498zm-.135 2.524h3.058v12.99h-3.058v-12.99zM251.262 25.56a6.278 6.278 0 01-2.238-2.497c-.535-1.054-.805-2.211-.805-3.473s.265-2.42.794-3.469a6.281 6.281 0 012.238-2.497c.961-.613 2.056-.924 3.287-.924.675 0 1.303.12 1.885.358.581.239 1.08.55 1.505.93.421.379.753.789.997 1.225l-.062-1.35V8.292h3.048v17.793h-2.908V23.9c-.42.743-1.023 1.355-1.802 1.843-.778.488-1.677.732-2.699.732-1.205 0-2.285-.306-3.24-.913zm5.727-2.44a3.85 3.85 0 001.391-1.474 4.197 4.197 0 00.514-2.061c0-.753-.171-1.433-.504-2.056a3.83 3.83 0 00-1.386-1.465 3.644 3.644 0 00-1.942-.534c-.711 0-1.365.176-1.947.524a3.743 3.743 0 00-1.376 1.449c-.337.617-.503 1.308-.503 2.087 0 .779.166 1.448.493 2.066a3.749 3.749 0 001.365 1.464c.582.359 1.241.535 1.973.535a3.54 3.54 0 001.927-.535h-.005zM267.04 25.555c-.934-.612-1.666-1.448-2.201-2.502-.53-1.054-.794-2.207-.794-3.463 0-1.257.264-2.399.804-3.453.535-1.054 1.267-1.89 2.202-2.508a5.497 5.497 0 013.105-.93c1.059 0 2.004.23 2.824.691a4.556 4.556 0 011.864 1.9v-2.2h2.908v12.99h-2.908v-2.186c-.42.81-1.043 1.438-1.864 1.895-.82.457-1.76.68-2.814.68a5.528 5.528 0 01-3.12-.924l-.006.01zm5.784-2.445a3.84 3.84 0 001.387-1.464 4.221 4.221 0 00.503-2.056c0-.753-.171-1.423-.514-2.04a3.935 3.935 0 00-1.386-1.475 3.548 3.548 0 00-1.921-.545c-.701 0-1.34.17-1.921.514a3.745 3.745 0 00-1.386 1.433c-.343.612-.514 1.318-.514 2.108 0 .789.171 1.531.519 2.15.348.617.81 1.084 1.391 1.416a3.82 3.82 0 001.906.494c.69 0 1.339-.177 1.926-.535h.01zM283.079 25.057c-.815-.685-1.225-1.988-1.225-3.91v-5.42h-2.69V13.1h2.69V9.294l3.058-.026V13.1h3.894v2.627h-3.894v5.56c0 1.506.628 2.264 1.884 2.264h2.01v2.54h-2.643c-1.241 0-2.269-.343-3.084-1.029v-.005zM290.898 10.571c-.342-.332-.514-.753-.514-1.256 0-.504.172-.914.514-1.246.343-.333.805-.499 1.387-.499.581 0 1.059.166 1.401.499.343.332.52.747.52 1.246 0 .498-.172.934-.52 1.261-.347.327-.815.493-1.417.493-.602 0-1.028-.166-1.371-.498zm-.135 2.524h3.058v12.99h-3.058v-12.99zM299.289 25.555a6.64 6.64 0 01-2.446-2.497c-.592-1.049-.882-2.207-.882-3.468 0-1.262.295-2.41.882-3.463a6.616 6.616 0 012.446-2.503c1.038-.613 2.206-.924 3.504-.924s2.482.306 3.526.924a6.555 6.555 0 012.45 2.503c.592 1.054.883 2.206.883 3.463 0 1.256-.296 2.425-.883 3.473a6.554 6.554 0 01-2.455 2.498c-1.049.612-2.228.913-3.531.913s-2.456-.306-3.494-.924v.005zm5.472-2.44a3.725 3.725 0 001.366-1.438c.332-.613.498-1.308.498-2.087 0-.78-.166-1.46-.498-2.077a3.709 3.709 0 00-1.371-1.454 3.725 3.725 0 00-1.947-.524 3.72 3.72 0 00-1.947.524 3.695 3.695 0 00-1.371 1.454c-.332.618-.498 1.313-.498 2.077 0 .763.166 1.47.498 2.087a3.675 3.675 0 001.366 1.438c.576.348 1.23.52 1.952.52s1.376-.172 1.952-.52zM314.714 13.095v2.024c.379-.726.966-1.308 1.766-1.75.794-.44 1.687-.664 2.674-.664 1.729 0 3.027.55 3.904 1.64.878 1.091 1.314 2.675 1.314 4.741v7h-3.058v-6.938c0-1.246-.26-2.165-.784-2.746-.525-.587-1.262-.878-2.223-.878-.612 0-1.183.156-1.708.463-.524.306-.94.757-1.256 1.35-.317.591-.473 1.297-.473 2.118v6.635h-3.058V13.1h2.908l-.006-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F6CDB6",
                        d: "M1.62 27.565l3.863 5.753a9.02 9.02 0 011.667-.478c.591-.109 1.157-.042 1.604-.047 1.485-.124 6.158 1.625 9.08 2.134.806.14 1.195.047 1.725-.047.373-.067 5.337-3.395 7.154-5.051a33.921 33.921 0 005.426-6.324.48.48 0 00-.125-.66l-.135-.093a.744.744 0 00-.591-.114l-.322.072c-.187.042-.55.177-.987.384-.327.208-1.625 1.568-1.916 1.823l-1.952 1.438-1.75 1.319c-.804.311-2.29.877-2.69 1.132-.305.192-1.655.96-1.962 1.09 0 0-.327-.13-.945-.14-.239 0-1.012.14-1.11.067l-.105-.244a4.63 4.63 0 01-.026-1.163c.052-.467 1.371-.493 1.371-.493l1.584.052 3.489-.286c.908-.046 1.308-.835 1.34-1.35l-.021-.654c-.068-.721-.774-1.21-1.226-1.215l-3.567-.212a18.533 18.533 0 01-5.524-.41c-1.36-.265-1.309-.515-4.694-.702-3.806.203-7.923 3.225-8.665 4.419h.01z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#0067A5",
                        d: "M7.695 33.001l-5.39-7.606L0 26.91l5.312 7.637 2.383-1.547zM18.676 6.246c-2.061 0-3.572-.737-3.666-.784a.624.624 0 01-.28-.841c.156-.312.441-.384.841-.28.031.015 2.695 1.427 6.065.098.342-.135.685-.015.835.296a.628.628 0 01-.296.836c-1.23.582-2.435.675-3.494.675h-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#0067A5",
                        d: "M22.7 2.45c-.078.785-.763 1.584-1.532 1.771-.42.13-.986.244-.986.244-.769.187-1.973.171-2.825.062-.805-.176-1.687-.508-1.687-.508-.764-.192-1.516-.982-1.672-1.755l-.26-1.288c-.155-.774.317-1.168 1.054-.877L18.338 1.5c.733.291 1.864.161 2.514-.285l.929-.639c.649-.446 1.116-.171 1.044.613l-.12 1.267-.005-.005zM17.03 11.402c0 .213.093.39.275.54.14.12.384.239.795.358v-1.74c-.307.047-.572.14-.774.291a.651.651 0 00-.29.55h-.006zM19.6 14.58a8.404 8.404 0 00-.722-.208v2.352c.442-.026.852-.146 1.117-.364.29-.244.436-.53.436-.856a.8.8 0 00-.187-.535c-.125-.146-.337-.275-.644-.384v-.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#0067A5",
                        d: "M21.802 16.931c-.286.447-.68.774-1.2.992-.472.197-1.043.306-1.724.322v.815h-.784v-.841c-.851-.078-1.526-.327-2.02-.753-.602-.52-.965-1.277-1.084-2.274l1.75-.171c.103.586.321 1.017.643 1.293.192.166.405.28.712.347V14.17c-.95-.234-1.579-.524-1.958-.862-.545-.488-.825-1.085-.825-1.791 0-.452.13-.877.384-1.272s.633-.696 1.116-.904a4.119 4.119 0 011.282-.29V8.032h.784V9.04c.95.042 1.698.286 2.207.727.566.488.852 1.143.883 1.958l-1.797.078c-.078-.457-.238-.784-.488-.987-.197-.156-.467-.25-.805-.285v1.973s.047.01.073.02c.872.208 1.511.42 1.932.639.42.218.747.52.98.903.24.385.36.857.36 1.418 0 .509-.141.986-.421 1.433v.015zm6.568 2.991a3.537 3.537 0 00-.707-.909c-.352-.327-.368-.67-.295-1.121.088-.602.119-1.22.103-1.828-.03-1.422-.436-2.767-.976-4.07-.94-2.27-2.227-4.294-4.19-5.826-.13-.104-.384-.16-.535-.114-2.087.664-4.174.623-6.256 0-.244-.073-.395-.073-.597.088C12.84 7.81 11.48 9.98 10.55 12.43c-.69 1.807-1.033 3.67-.602 5.623.057.26-.182.602-.343.867-.192.317-.508.55-.695.867-.473.794-.135 1.464.789 1.485.587.01 1.173-.171 1.76-.234.343-.036.753-.057 1.038.078 1.937.93 4.003 1.085 6.085 1.148 2.01-.058 4.035-.182 5.873-1.039.509-.239.919-.3 1.464-.16.566.15 1.179.233 1.76.186.753-.057 1.049-.664.696-1.329h-.005z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_0_5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H324.372V35H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (FastDebtConsolidationLogo);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/fastDebtConsolidationWrapper.tsx










const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function FastDebtConsolidationWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { visitDetails  } = (0,useDomainContext/* useDomainContext */.w)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Fast Debt Consolidation",
                    domain: "FastDebtConsolidation.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Fast Debt Consolidation",
                    domain: "FastDebtConsolidation.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: `The best debt relief analysis compensation in ${visitDetails.region} `,
                        phoneNumberColor: (fastdebtconsolidationVariables_module_default()).mainColor,
                        iconColor: (fastdebtconsolidationVariables_module_default()).mainColor,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 88043:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#204b6e"};

/***/ })

}]);